(function () {
    'use strict';
    angular.module('SMART2').factory('notification', [function () {
        var Obj = {};
        Obj.show = false;
        Obj.onCallback = undefined;

        Obj.on = function (callback) {
            Obj.onCallback = callback;
        };

        Obj.notify = function (config, callback) {
            this.show = true;
            this.config = config;
            this.broadcastItem();
            this.resultCallBack = function (result) {
                if (typeof (callback) == 'function') {
                    setTimeout(function () {
                        callback(result);
                    });
                }
            };
        };

        Obj.broadcastItem = function () {
            angular.isFunction(Obj.onCallback) && Obj.onCallback();
        };

        return Obj;
    }]);

    angular.module('SMART2').directive('smartNotification', ['$rootScope', 'notification', '$translate', '$sce', '$timeout', '$focusOnField', function ($rootScope, notification, $translate, $sce, $timeout, $focusOnField) {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                showN: "@"
            },
            link: function (scope, element, attrs) {
                var topPositionBeforeModalOpen = 0;

                /*
                 *  Unbind window keyup listener and assign tabindex back to .picker elements
                 */
                var reset = function () {
                    $(window).off('keyup', onWindowKeyUp);
                    angular.element('.picker').attr("tabindex", 0);
                    angular.element(document).scrollTop(topPositionBeforeModalOpen);
                };

                /*
                 *  window on key up event listener
                 */
                var onWindowKeyUp = function (e) {
                    if (angular.element(e.target).closest('.modal').length == 0 && e.keyCode == 9) {
                        angular.element(element.find(':focusable')[0]).focus();
                    }
                };

                /*
                 *  hide notification pop up when route changed
                 */

                scope.$on('$stateChangeSuccess', function () {
                    if (scope.showN && !(scope.config.type == "unsupportedBrowserVersion" || scope.config.type == "unsupportedBrowser")) {
                        scope.showN = false;
                        cleanUpNotificationPopup();
                    }
                });

                /*
                 *  On notification listener
                 */
                scope.dismissible = true;
                notification.on(function () {
                    scope.dismissible = angular.isDefined(notification.config.dismissible) ? notification.config.dismissible : true;
                    scope.config = notification.config;
                    scope.buttons = scope.config.buttons;
                    switch (scope.config.type) {
                        case "success":
                            scope.notifyClass = 'notify-success';
                            scope.title = $translate.instant("notificationSuccessMsg");
                            scope.icon = "#icon_CircleCheck";
                            break;
                        case "error":
                            scope.notifyClass = 'notify-error';
                            scope.title = $translate.instant("notificationErrorMsg");
                            scope.icon = "#icon_Exclamation";
                            break;
                        case "warning":
                            scope.notifyClass = 'notify-warning';
                            scope.icon = "#icon_Warning";
                            scope.title = $translate.instant("notificationWarningMsg");
                            break;
                        case "confirm":
                            scope.notifyClass = 'notify-confirm';
                            scope.icon = "#icon_Help";
                            scope.title = $translate.instant("notificationConfirmationMsg");
                            break;
                        case "inform":
                            scope.notifyClass = 'notify-information';
                            scope.icon = "#icon_Info";
                            scope.title = $translate.instant("notificationInformationMsg");
                            break;
                        case "sessionTimeOut":
                            scope.notifyClass = 'notify-session-timeout';
                            scope.icon = "#icon_AlertTimer";
                            scope.title = $translate.instant("notificationSessionTimeOut");
                            scope.dismissible = false;
                            break;
                        case "sessionExpire":
                            scope.notifyClass = 'notify-session-expire';
                            scope.icon = "#icon_AlertTimer";
                            scope.title = $translate.instant("notificationSessionExpiredMsg");
                            scope.dismissible = false;
                            break;
                        case "unsupportedBrowserVersion":
                            scope.notifyClass = "notify-unsupported-browser-version";
                            scope.titleTextColor = "browser-version-header-text";
                            scope.title = $translate.instant("notificationUnsupportedBrowserVersionMsg");
                            break;
                        case "unsupportedBrowser":
                            scope.notifyClass = "notify-unsupported-browser";
                            scope.titleTextColor = "browser-unsupported-header-text";
                            scope.title = $translate.instant("notificationUnsupportedBrowserMsg");
                    };
                    //scope.dismissible = (typeof notification.config.dismissible != "undefined")?(notification.config.dismissible) ? true : false : scope.dismissible;
                    scope.message = $sce.trustAsHtml(scope.config.message);
                    scope.checkboxText = scope.config.checkMessage;
                    scope.customTemplate = false;
                    if (typeof scope.config["isMultipleCheck"] != "undefined" && scope.config["isMultipleCheck"]) {
                        scope.customTemplate = true;
							  if(typeof scope.config.modalType == "undefined" ){
								  scope.config.modalType="small"
                        }
                        for (var i in scope.config.multipleCheckList) {
                            scope.config.multipleCheckList[i].model = {};
                            scope.config.multipleCheckList[i].model.modelName = scope.config.multipleCheckList[i]["checkContext"];
                            switch (scope.config.multipleCheckList[i].type) {
                                case "check":
                                    scope.config.multipleCheckList[i].model.isCheck = false;
                                    break;
                                case "radio":
                                    scope.config.multipleCheckList[i].model.isCheck = {
                                        "title": ""
                                    };
                                    break;
                            }
                            if (typeof scope.config.multipleCheckList[i]["header"] != "undefined" && typeof scope.config.multipleCheckList[i]["header"] == "string") {
                                scope.config.multipleCheckList[i]["header"] = $sce.trustAsHtml(scope.config.multipleCheckList[i]["header"]);
                            }
                            if (typeof scope.config.multipleCheckList[i]["label"] == "string") {
                                scope.config.multipleCheckList[i]["label"] = $sce.trustAsHtml(scope.config.multipleCheckList[i]["label"]);
                            }
                        }
                        for (var i in scope.config.buttons) {
                            if (typeof scope.config.buttons[i].disableBtn != "undefined") {
                                scope.config.buttons[i].disableBtn = true;
                            }
                        }
                    }
                    scope.isCheckSelect = false;
                    if (typeof scope.config.isCheckSelect != 'undefined') {
                        scope.isCheckSelect = scope.config.isCheckSelect;
                    }
                    scope.showN = notification.show;

                    angular.element('body').css('overflow', 'hidden');
                    $timeout(function () {
                        var $firstField = element.find(':focusable')[0];
                        $focusOnField($firstField);
                        $(window).on('keyup', onWindowKeyUp);
                        //  remove picker tabindex when popup to avoid focus on picker element
                        angular.element('.picker').removeAttr("tabindex");
                        scope.notifyClass = scope.notifyClass + ' notificationanimate--active';
                    }, 250);
                    topPositionBeforeModalOpen = angular.element(document).scrollTop();
                });

                scope.showN = false;
                scope.bindforTab = false;
                scope.overlayCLicked = function () {
                    if (scope.dismissible) {
                        //scope.showN = false;
                        //cleanUpNotificationPopup();
                    }
                }
                scope.$on('LastRepeaterElement', function () {
                    scope.bindforTab = true;
                });
                scope.onChangeNotification = function() {
                    var cnt = 0;
                    for (var i in scope.config.multipleCheckList) {
                        if (scope.config.multipleCheckList[i].model.isCheck) {
                            if (typeof scope.config.multipleCheckList[i].isMandatory != "undefined" && scope.config.multipleCheckList[i].isMandatory) {
                            cnt++;
                        }
							
                    }
						if (typeof scope.config.multipleCheckList[i].disable != "undefined" && typeof scope.config.multipleCheckList[i].enableOn != "undefined") {
								scope.config.multipleCheckList[i].disable=!getStatus(scope.config.multipleCheckList[i].enableOn);
						}
                    }
                    for (var i in scope.config.buttons) {
                        if (typeof scope.config.buttons[i].disableBtn != "undefined") {
                            if (cnt > 0) {
                                scope.config.buttons[i].disableBtn = false;
                            } else {
                                scope.config.buttons[i].disableBtn = true;
                            }
                        }
                    }

                }
				 function getStatus(mdlName){
				    for (var i in scope.config.multipleCheckList) {
                        if (scope.config.multipleCheckList[i].model.modelName == mdlName) {
                           return scope.config.multipleCheckList[i].model.isCheck;
                        }
                    }
				}
                scope.clickCallbackFunction = function (e) {
                    $timeout(function () {
                        scope.showN = false;
                        scope.bindforTab = false;
                        var responceObj = {
                            "result": e
                        };
                        if(scope.customTemplate){
                            for (var i in scope.config.multipleCheckList) {
                                 responceObj[scope.config.multipleCheckList[i].model.modelName] =  scope.config.multipleCheckList[i].model.isCheck
                            }
                        }else{
                            responceObj["isChecked"] = scope.isCheckSelect;
                        }
                        cleanUpNotificationPopup();
                        notification.resultCallBack(responceObj);
                        $rootScope.$broadcast("closedPopup");
                    });
                };
                function cleanUpNotificationPopup() { // empty 'scope.buttons' object to avoid getting display multiple notification buttons
                    scope.notifyClass = '';
                    scope.buttons = [];
                    angular.element('body').css('overflow', '');
                    angular.element('.notification-massage .modal-content').css('display', 'none');
                    angular.element('.notification-massage .modal-footer').css('display', 'none');
                }
		$rootScope.$on('ClearLogoutNotificationPopup', function () {
                    scope.showN = false;
                    scope.bindforTab = false;
                    cleanUpNotificationPopup();
                    $rootScope.$broadcast("closedPopup");
                });
		  
                scope.$on('$destroy', function () {
                    reset();
                });
            },
            templateUrl: 'shared/directives/notification/notificationTemplate.html',
        }
    }]);
})();
